import { lensPath, view, set } from 'rambda';
import {
  FacetFilterValue,
  Refinements,
  NumericFilterValue,
  FacetFilter,
  UpdateRefinementsParams,
  Facet,
  FacetLayout,
} from '@packages/common';

export const mapFacetFilter = (
  facet: Facet,
  facetValue: FacetFilterValue,
  facetFilters: Refinements['facetFilters'],
): Refinements['facetFilters'] => {
  const { isHero, seoName, name, featureValue } = facetValue;

  const currentFacetFilter = facetFilters[facet.featureMapping];

  const lens = lensPath([facet.featureMapping]);

  const current: FacetFilter = view(lens, facetFilters);

  const valueIsRefined =
    currentFacetFilter && currentFacetFilter.values.filter((item) => item.seoName === seoName).length;
  return set(
    lens,
    {
      seoName: facet.seoName,
      relation: facet.relation,
      values: valueIsRefined
        ? currentFacetFilter.values.filter((item) => item.seoName !== seoName)
        : [...(current ? current.values : []), { isHero, seoName, name, featureValue }],
    },
    facetFilters,
  );
};

export const mapNumericFilter = (
  facet: Facet,
  numericFilter: NumericFilterValue,
  numericFilters: Refinements['numericFilters'],
): Refinements['numericFilters'] =>
  set(
    lensPath([facet.featureMapping]),
    {
      seoName: facet.seoName,
      unit: facet.unit,
      relation: facet.relation,
      value: numericFilter,
    },
    numericFilters,
  );

export const updateRefinements = ({ refinements, facet, facetValue, numericValue }: UpdateRefinementsParams) => {
  if (facet && facet.layout === FacetLayout.SLIDER && numericValue) {
    return {
      ...refinements,
      numericFilters: mapNumericFilter(facet, numericValue, refinements.numericFilters),
    };
  }
  if (facetValue) {
    return {
      ...refinements,
      facetFilters: mapFacetFilter(facet, facetValue, refinements.facetFilters),
    };
  }
  return refinements;
};
